import { Ward } from './ward.model';

export class InstitutionInfo {
  institutionId: number;

  institutionName: string;

  institutionKana: string;

  tel: string;

  fax: string;

  address: string;

  comment: string;

  wards: Ward[];

  cityId: number;

  updateTime: Date;

  update(source: InstitutionInfo) {
    this.institutionId = source.institutionId;
    this.institutionName = source.institutionName;
    this.institutionKana = source.institutionKana;
    this.tel = source.tel;
    this.fax = source.fax;
    this.address = source.address;
    this.comment = source.comment;
    this.wards = source.wards;
    this.cityId = source.cityId;
    this.updateTime = source.updateTime;
    this.wards = source.wards;
  }
}
